t = require('app/scripts/views/internal/teacup-with-helpers')('popover_rename_board')

module.exports = ->
  t.form ->

    t.label ->
      t.format 'name'
    t.input '.js-board-name.js-autofocus', { type: 'text', value: t.mustacheVar('boardName'), dir: 'auto' }

    t.input '.primary.wide.js-rename-board', { type: 'submit', value: t.l('rename') }
